import styles from './SubjectPill.module.css';

interface SubjectPillProps {
  label: string;
}

export function SubjectPill({ label }: SubjectPillProps) {
  return <span className={styles.pill}>{label}</span>;
}
